import { useEffect, useState } from 'react';

// Runtime mobile check, tracking the viewport below Tailwind's `lg` breakpoint
// (1024px). Used where the mobile/desktop divergence is structural — a different
// component tree or state machine — rather than pure restyling that `lg:`
// classes could express.
//
// jsdom-safe: when `window.matchMedia` is undefined (the jsdom default) it
// reports desktop (false), so unit tests render the desktop tree unless they
// explicitly stub matchMedia.
const QUERY = '(max-width: 1023px)';

const getMatch = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(QUERY).matches;

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    // addEventListener is the modern API; addListener is the Safari fallback.
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return isMobile;
}
